import { render, staticRenderFns } from "./reset-password.page.vue?vue&type=template&id=2a0d7682&scoped=true&"
import script from "./reset-password.page.vue?vue&type=script&lang=js&"
export * from "./reset-password.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0d7682",
  null
  
)

export default component.exports